import * as React from "react";
import { SVGProps } from "react";
export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.99999 15.833C9.76399 15.833 9.55899 15.7463 9.38499 15.573C9.21166 15.399 9.12499 15.194 9.12499 14.958V10.875H5.04199C4.80599 10.875 4.60099 10.7883 4.42699 10.615C4.25366 10.441 4.16699 10.236 4.16699 10C4.16699 9.764 4.25366 9.559 4.42699 9.385C4.60099 9.21167 4.80599 9.125 5.04199 9.125H9.12499V5.042C9.12499 4.806 9.21166 4.601 9.38499 4.427C9.55899 4.25367 9.76399 4.167 9.99999 4.167C10.236 4.167 10.441 4.25367 10.615 4.427C10.7883 4.601 10.875 4.806 10.875 5.042V9.125H14.958C15.194 9.125 15.399 9.21167 15.573 9.385C15.7463 9.559 15.833 9.764 15.833 10C15.833 10.236 15.7463 10.441 15.573 10.615C15.399 10.7883 15.194 10.875 14.958 10.875H10.875V14.958C10.875 15.194 10.7883 15.399 10.615 15.573C10.441 15.7463 10.236 15.833 9.99999 15.833Z"
            fill="currentColor"
        />
    </svg>
);
PlusIcon.displayName = "PlusIcon";
